import request from '@/utils/http'

const PREFIX = '/synSource'

const synSource = {
  create(params) {
    return request(
      `${PREFIX}`,
      'post',
      params
    )
  },

  update(id, params) {
    return request(
      `${PREFIX}/${id}`,
      'put',
      params
    )
  },

  page(params) {
    return request(
      `${PREFIX}`,
      'get',
      params
    )
  },

  list() {
    return request(
      `${PREFIX}/list`,
      'get'
    )
  },

  delete(id) {
    return request(
      `${PREFIX}/` + id,
      'delete'
    )
  },

  test(id) {
    return request(
      `${PREFIX}/test/${id}`,
      'get'
    )
  }
}

export default synSource
